import { render, staticRenderFns } from "./WinsTiesLosses.vue?vue&type=template&id=21a185a0&scoped=true&"
import script from "./WinsTiesLosses.vue?vue&type=script&lang=ts&"
export * from "./WinsTiesLosses.vue?vue&type=script&lang=ts&"
import style0 from "./WinsTiesLosses.vue?vue&type=style&index=0&id=21a185a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a185a0",
  null
  
)

export default component.exports